import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { style: {"font-size":"x-large","margin-right":"50px"} }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "col-sm-3 col-xs-12 row justify-end items-end q-pa-md" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"larger","text-align":"end"} }, "Стоимость за", -1)
const _hoisted_5 = { style: {"font-size":"larger","text-align":"end"} }
const _hoisted_6 = {
  key: 0,
  class: "text-strike text-negative text-subtitle1 text-right"
}
const _hoisted_7 = { class: "text-h6 text-weight-bold text-right" }
const _hoisted_8 = { class: "row justify-end q-mt-sm" }
const _hoisted_9 = { style: {"font-size":"x-large"} }
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_q_btn, {
        ref: "changeRoom",
        id: "changeRoomBtn",
        icon: "mdi-undo-variant",
        flat: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => {
          delete _ctx.actualRoom.selectedRoom;
          _ctx.actualRoom.roomStep = 'room';
        })
      }, {
        default: _withCtx(() => [
          _createTextVNode("Изменить номер ")
        ]),
        _: 1
      }, 512)
    ]),
    _createVNode(_component_q_tabs, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event)),
      dense: "",
      class: "text-grey",
      "active-color": "primary",
      "indicator-color": "primary",
      align: "justify",
      "narrow-indicator": ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actualRoom.selectedRoom?.guests, (guest) => {
          return (_openBlock(), _createBlock(_component_q_tab, {
            key: guest.idx,
            name: guest.idx,
            label: guest.age === -1 ? `Взрослый ${guest.idx}` : `Ребенок ${_ctx.formateAge(guest.age)}`
          }, null, 8, ["name", "label"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_tab_panels, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tab) = $event)),
      animated: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actualRoom.selectedRoom?.guests, (guest) => {
          return (_openBlock(), _createBlock(_component_q_tab_panel, {
            class: "row justify-center",
            key: guest.idx,
            name: guest.idx
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(guest.tariffs, (tariff) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["col-sm-12 col-md-6", {
            'q-pl-lg': !_ctx.$q.screen.lt.md,
            'q-pt-lg': !_ctx.$q.screen.lt.md,
            'q-pb-lg': _ctx.$q.screen.lt.md,
          }]),
                  key: tariff.tariffId
                }, [
                  _createVNode(_component_q_card, {
                    style: _normalizeStyle({ height: _ctx.$q.screen.lt.md ? 'auto' : '100%' }),
                    class: "row justify-between full"
                  }, {
                    default: _withCtx(() => [
                      (
                _ctx.actualRoom.searchResult?.availableTariff.find(
                  (avTariff) => avTariff.id == tariff.tariffId
                )?.promotion_file
              )
                        ? (_openBlock(), _createBlock(_component_q_img, {
                            key: 0,
                            class: "q-ma-sm",
                            style: {"position":"absolute","z-index":"2","right":"0px"},
                            width: "50px",
                            height: "50px",
                            src: 
                _ctx.baseUrl +
                '/client_data/image/' +
                _ctx.actualRoom.searchResult?.availableTariff.find(
                  (avTariff) => avTariff.id == tariff.tariffId
                )?.promotion_file
              
                          }, null, 8, ["src"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_q_card_section, { class: "col-sm-8 col-xs-12" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, _toDisplayString(tariff.tariffDescription), 1),
                          _createVNode(_component_q_separator, { style: {"margin-top":"5px","margin-bottom":"5px"} }),
                          _createElementVNode("div", {
                            style: {"white-space":"pre-line"},
                            innerHTML: 
                  _ctx.actualRoom.searchResult?.availableTariff.find(
                    (avTariff) => avTariff.id == tariff.tariffId
                  )?.info
                
                          }, null, 8, _hoisted_2)
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", null, [
                          _hoisted_4,
                          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.formattedSelectedDate.days) + " " + _toDisplayString(_ctx.formateDayNight(_ctx.formattedSelectedDate.days)), 1),
                          (tariff.show_discount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.discountFormat(tariff.fullPrice, tariff.show_discount)), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_7, _toDisplayString(tariff.fullPrice.toLocaleString('ru-RU', {
                      style: 'currency',
                      currency: 'RUB',
                    })), 1),
                          _createElementVNode("div", _hoisted_8, [
                            (guest.selectTariff !== tariff)
                              ? (_openBlock(), _createBlock(_component_q_btn, {
                                  key: 0,
                                  style: {"width":"120px","font-size":"16px"},
                                  onClick: ($event: any) => {
                      guest.selectTariff = tariff;
                      _ctx.nextTariff();
                    }
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Выбрать ")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : (_openBlock(), _createBlock(_component_q_btn, {
                                  key: 1,
                                  color: "primary",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nextTariff()))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Продолжить")
                                  ]),
                                  _: 1
                                }))
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["style"])
                ], 2))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actualRoom.searchResult?.otherTariff, (tariff) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([{
            'q-pl-lg': !_ctx.$q.screen.lt.md,
            'q-pt-lg': !_ctx.$q.screen.lt.md,
            'q-pb-lg': _ctx.$q.screen.lt.md,
          }, "col-sm-12 col-md-6"]),
                  key: tariff.id
                }, [
                  _createVNode(_component_q_card, {
                    style: _normalizeStyle({ height: _ctx.$q.screen.lt.md ? 'auto' : '100%' }),
                    class: "row justify-between full"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card_section, { class: "col-sm-8 col-xs-12" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(tariff.description), 1),
                          _createVNode(_component_q_separator, { style: {"margin-top":"5px","margin-bottom":"5px"} }),
                          _createElementVNode("div", {
                            style: {"white-space":"pre-line"},
                            innerHTML: tariff.info
                          }, null, 8, _hoisted_10)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_banner, {
                        style: {"width":"100%"},
                        dense: "",
                        class: "bg-grey-2 text-negative text-center q-mt-sm"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tariff.otherDescription), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["style"])
                ], 2))
              }), 128))
            ]),
            _: 2
          }, 1032, ["name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}